import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from 'seagull/components/Typography';
import { useLocaleKeys } from '~/i18n';
const UnbilledTimeActivities = (param)=>{
    let { serviceTimeActivitiesLength } = param;
    const { t: commonTexts } = useLocaleKeys('common');
    return /*#__PURE__*/ _jsx(Typography, {
        testId: "unbilled-time-activities",
        variant: "paragraph2",
        skin: "success",
        children: commonTexts.units.unbilledActivitiesCount({
            count: serviceTimeActivitiesLength
        })
    });
};
export default UnbilledTimeActivities;
